import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../context/userContext";
import { useNavigate, useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import { Row, Col, Form, Input, Label, Button, CardText, CardTitle, FormFeedback, UncontrolledTooltip } from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { API, setAuthToken } from "../../../config/api";
import { FaUser, FaUserMd, FaGenderless, FaMailBulk, FaTransgender, FaPhone, FaAddressBook, FaAddressCard, FaEdit, FaTrash, FaSave, FaPlus, FaSearch, FaUserAlt, FaAccessibleIcon, FaCriticalRole, FaUserClock, FaUserCheck, FaAccusoft, FaArchive, FaBackspace, FaBackward, FaArrowCircleLeft, FaRegArrowAltCircleLeft, FaEyeDropper, FaRegEye, FaMehRollingEyes, FaBullseye, FaStreetView, FaEye, FaPerbyte, FaAngleUp, FaAdjust, FaMizuni, FaCreativeCommonsZero, FaCreativeCommons, FaAward, FaStethoscope, FaListOl, FaDAndD, FaDailymotion, FaGasPump, FaDesktop, FaFileMedical, FaBookMedical, FaCalendar, FaCalendarDay, FaCalendarAlt, FaTransgenderAlt, FaBirthdayCake, FaCalendarCheck, FaPhoenixFramework, FaPhoneAlt, FaPhoneSlash, FaMobile, FaMobileAlt, FaMarsStroke, FaWpforms, FaSync, FaUserPlus, FaTag, FaRegEdit, FaUserEdit, FaTimes } from 'react-icons/fa'
import ReactPaginate from "react-paginate";
import Modal from 'react-bootstrap/Modal';
import logo_side from "../../../assets/signature/logo-side-detail.png"
import Logo_Signature from "../../../assets/signature/signatureNewIcon.png"
import Logo_Batik from "../../../assets/signature/logo-batik.png"
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../Styled.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
import LoaderHome from "../../Loader/LoaderHome"
import TableCategoryTreatment from "../ModalAdminTreatment/Components/TableTreatmentCategory";

export default function ModalRoleUpdate(props) {
  const navigate = useNavigate()
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5000); // tetap 10 per halaman
  const [allTreatments, setAllTreatments] = useState([]); // semua data
  const [pages, setPages] = useState();
  const [ascending, setAscending] = useState(0);
  const token = localStorage.getItem("token");
  const [rows, setRows] = useState(1);
  const [msg, setMsg] = useState("");

  const [getDataDokter, setGetDataDokter] = useState([]);
  const [getDataCategory, setGetDataCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [treatmentCategoryName, setTreatmentCategoryName] = useState(null);
  const [treatments, setTreatment] = useState([]);
  const [propsData, setProopsData] = useState()
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");

  let fetchParams = {
    headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
  };

  const GetResponseData = async (pageNumber = 1) => {
    try {
      setLoading(true);

      const response = await API.get(
        // `transaction-service/treatment-categories/by/${props.id}?page=${pageNumber}&limit=${limit}&search=${keyword}`,
        `transaction-service/treatment-categories/by/${props.id}?page=${pageNumber}&limit=${limit}&search=${keyword}`,
        fetchParams
      );

      if (response?.status === 200) {
        setTreatmentCategoryName(response.data.data.category.name);
        setTreatment(response.data.data.treatments);
        setPage(response.data.paginationTreatment.current_page);
        setPages(response.data.paginationTreatment.total_pages);
        setRows(response.data.paginationTreatment.total);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (error.response?.status === 401) {
        navigate("/dashboard");
        swal({
          title: "Failed",
          text: "Akses dibatasi Tidak Dapat Mengakses Halaman Ini",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
      } else {
        swal({
          title: "Failed",
          text: `${error.response?.data?.message || "Terjadi kesalahan"}`,
          icon: "error",
          timer: 3000,
          buttons: false,
        });
      }
    }
  };


  useEffect(() => {
    if (props?.id) {
      GetResponseData(page);
    }
  }, [page, props?.id, keyword]);


  const changePage = ({ selected }) => {
    setPage(selected + 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeyword(query);
  };

  console.log("query:", query)
  console.log("keyword:", keyword)
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered style={{ fontFamily: "sans-serif", border: "none" }}>
      {loading && <LoaderHome />}
      <div style={{ width: "100%", display: "flex", padding: "10px 0px", backgroundColor: "#29B8FF" }}>
        <div style={{ flex: "92%", fontSize: "20px", display: "flex", alignItems: "center", paddingLeft: "10px", color: "white", fontWeight: "600" }}>
          Treatment {treatmentCategoryName}
        </div>
        <div style={{ flex: "8%", fontSize: "30px", display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>
          <FaTimes onClick={() => setProopsData(props.onHide)} style={{ cursor: "pointer" }} />
        </div>
      </div>
      <Modal.Body style={{ backgroundColor: "", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", border: "none" }}>
        <TableCategoryTreatment
          getData={treatments}
          rows={rows}
          page={page}
          setPage={setPage}
          pages={pages}
          changePage={changePage}
          msg={msg}
          GetResponseData={GetResponseData}
          query={query}
          setQuery={setQuery}
          searchData={searchData}
          keyword={keyword}
          setKeyword={setKeyword}
        />

      </Modal.Body>
    </Modal>
  );
}
